import * as React from "react"
import { Global, css } from "@emotion/core"
import { ThemeProvider, Theme } from "gatsby-interface"

import { SkipNavTrigger } from "../components/shared/components/SkipNav"
import Header from "./header"
import Footer from "./footer"

import { SubNavProps } from "./header/subnav"

import interVariableWoff2 from "../assets/fonts/inter/inter-v8-latin-variable.woff2"
import interRegularWoff2 from "../assets/fonts/inter/inter-v8-latin-regular.woff2"
import interRegularWoff from "../assets/fonts/inter/inter-v8-latin-regular.woff"
import interBoldWoff2 from "../assets/fonts/inter/inter-v8-latin-700.woff2"
import interBoldWoff from "../assets/fonts/inter/inter-v8-latin-700.woff"

/*
 * Consider refactoring and DRYing up:
 * - Consider DRYing up: contentPositionerCss
 */

const globalStyles = css`
  @font-face {
    font-family: "Inter";
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url(${interVariableWoff2}) format("woff2-variations"),
      url(${interRegularWoff2}) format("woff2"),
      url(${interRegularWoff}) format("woff");
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
      U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212,
      U+2215, U+FEFF, U+FFFD;
  }

  @font-face {
    font-family: "Inter";
    font-style: normal;
    font-weight: 700;
    font-display: swap;
    src: url(${interVariableWoff2}) format("woff2-variations"),
      url(${interBoldWoff2}) format("woff2"),
      url(${interBoldWoff}) format("woff");
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
      U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212,
      U+2215, U+FEFF, U+FFFD;
  }

  html {
    /* scroll to anchor links with padding on top */
    scroll-padding-top: 5rem;
    -webkit-font-smoothing: antialiased;
  }
`

interface LayoutBackgroundFunc {
  (_theme: Theme): string
}

interface LayoutProps {
  children: React.ReactNode
  background?: string | LayoutBackgroundFunc
  inverted?: boolean
  location?: Location
  subnav?: SubNavProps
  className?: string
}

const Layout = ({
  children,
  background,
  inverted,
  subnav,
  className = ``,
}: LayoutProps) => {
  const [withBanner, setWithBanner] = React.useState(false)

  return (
    <ThemeProvider
      theme={baseTheme => ({ ...baseTheme, useColorSchemeMediaQuery: false })}
    >
      <SkipNavTrigger />
      <Global styles={globalStyles} />
      <Header
        subnav={subnav}
        inverted={inverted}
        withBanner={withBanner}
        setWithBanner={setWithBanner}
      />
      <div
        css={theme => ({
          backgroundColor: background
            ? typeof background === `function`
              ? background(theme)
              : background
            : theme.colors.white,
        })}
        className={`${className} ${withBanner ? `withBanner` : ``}`}
      >
        {children}
        <Footer isInverted={inverted} />
      </div>
    </ThemeProvider>
  )
}

export default Layout
